;(function () {
    'use strict'

    var root
    var isNode
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }

    const gameRandom = (Device, updateParam, helpers, _, schemeId, currentMessage) => {
        return {
            allocate: (id, weights, playId) => {
                // return randomGenerator.allocate(id, weights, playId)
                var allocateUrl = 'allocate/' + id + '/' + Device.thrid + (weights ? '/' + JSON.stringify(weights) : '')
                return Device.gtp( allocateUrl, {messageId: playId || (currentMessage ? currentMessage.ATTRIBUTES.id : "noid")} )
            },
            realise: (id, options) => {
                // return randomGenerator.realise(id, options)
                var data = Object.assign({}, options, {})
                var realiseUrl = 'realise/' + schemeId + '/' + id + '/' + Device.thrid
                return Device.gtp(realiseUrl, data).then(function (data) {
                    try {
                        if (data.countNotRedeem) {
                            try {
                                if(!updateParam){
                                    throw new Error("Could not redeem: " + data.couldNotRedeem)
                                } else {
                                    // navigator.notification.alert(data.couldNotRedeem)
                                    updateParam("commonAlertMsg", {
                                        title: "",
                                        message: data.couldNotRedeem,
                                        severity: "error"
                                    })
                                }
                            }
                            catch (e) {
            
                            }
                        }
                        if (Device.shouldRefreshInfo(data)) {
                            try {
                                Device.getInfo()
                            }
                            catch (e) {
            
                            }
                        }
                        return data;
                    }
                    catch (e) {
                        console.error("Error in realise", e.stack)
                        return data
                        //topWindow.navigator.notification.alert(e.message + ' | ' + e.stack, 'ERROR');
                    }
            
                })
            },
            prizes: async (message, options) => {
                let prizeInfo = await (
                    Promise.all(
                        _.cloneDeep(_.get(message, "quantities.link.data.prizeInfo.prizes", [])).map(async (p) => {
                            if(options?.count && p.unlock) {
                                p.count = await (Device.gtp("count/:code", {code: p.unlock}))
                            }
                            
                            if(p.customFields) {
                                p.resolvedCustomFields = helpers.resolveThreeRadical(p.customFields, 'threeRadical', true, () => { return null })
                                delete p.customFields
                            }
                            
                            return p
                        })
                    )
                )
                
                let errors = prizeInfo.filter(p => p.count?.error)
                if(errors.length > 0) {
                    throw new Error("At least one prize unlock sent back a counting error: " + errors.map(p => p.unlock).join(", "))
                }
                
                return prizeInfo
            },
            dice: (id, options) => {
                var data = Object.assign({}, options, {})
                var diceUrl = 'random/dice/' + schemeId + '/' + id + '/' + Device.thrid
                return Device.gtp(diceUrl, data)
            }
        }
    }
    
    function factory(Device, updateParam, helpers, _, message) {
        return gameRandom(Device, updateParam, helpers, _, Device.schemeId, message)
        
    }
    
    factory._depends = {
        symbol : "3r/chi/factories/random",
        modules : [
            "3r/Device",
            "3r/chi/systemMessage",
            "3r/chi/helpers",
            "_"
        ]
    }

    if (isNode) {
        module.exports = {
            gameRandom: gameRandom,
            factory : factory
        }
    } else {
        root.GameRandom = gameRandom
    }
})()